import Phaser from 'phaser';
import { NetworkManager } from '../managers/NetworkManager';
import { applyRenderScale, forceCanvasRenderer } from '../config';
import { UrlStateManager } from '../utils/UrlStateManager';

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  preload(): void {
    // No assets to load in boot scene
  }

  create(): void {
    applyRenderScale(this);

    // Set up WebGL context loss handling for iOS stability
    this.setupWebGLContextLossHandling();

    // Parse URL state early for auto-join and configuration
    const joinConfig = UrlStateManager.getJoinConfig();

    // Initialize NetworkManager as singleton
    const networkManager = new NetworkManager();
    this.registry.set('networkManager', networkManager);

    // Initialize game state storage
    this.registry.set('gameState', null);
    this.registry.set('playerName', joinConfig.playerName);
    this.registry.set('joinConfig', joinConfig);

    this.scene.start('PreloadScene');
  }

  /**
   * Set up handlers for WebGL context loss/restoration.
   * iOS Safari can reclaim WebGL contexts under memory pressure.
   */
  private setupWebGLContextLossHandling(): void {
    const canvas = this.game.canvas;

    canvas.addEventListener('webglcontextlost', (event) => {
      event.preventDefault();
      console.error('[Hokm] WebGL context lost - iOS Safari may have reclaimed memory');

      // Force Canvas mode on next reload for stability
      forceCanvasRenderer();

      // Show user-friendly message before reload
      this.showContextLostMessage();
    });

    canvas.addEventListener('webglcontextrestored', () => {
      console.log('[Hokm] WebGL context restored - reloading game');
      window.location.reload();
    });
  }

  /**
   * Show a brief message to the user before reloading after context loss.
   */
  private showContextLostMessage(): void {
    // Create a simple overlay message
    const overlay = document.createElement('div');
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #1a4a3a;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10000;
      color: white;
      font-family: sans-serif;
      font-size: 18px;
      text-align: center;
      padding: 20px;
    `;
    overlay.innerHTML = 'Recovering from graphics error...<br>Reloading game.';
    document.body.appendChild(overlay);

    // Reload after brief delay to show message
    setTimeout(() => window.location.reload(), 1500);
  }
}
